var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "cost-table-dialog",
          attrs: {
            title: "费用明细",
            width: "700px",
            visible: _vm.dialogVisible
          },
          on: { close: _vm.close }
        },
        [
          _vm.details
            ? _c("div", { staticClass: "cost-detail-wrapper" }, [
                _c("div", { staticClass: "cost-content" }, [
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("起点：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.city_from))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("终点：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.city_to))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("承运方：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.carrier))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("费用号：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.accrualBasisNo))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("订单号：")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-url",
                        on: { click: _vm.goOrderDetail }
                      },
                      [_vm._v(_vm._s(_vm.details.orderNo))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("账单号：")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-url",
                        on: { click: _vm.goBillDetail }
                      },
                      [_vm._v(_vm._s(_vm.details.billNo))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("确认送达时间：")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("timeFormat")(_vm.details.createTime))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("金额：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.totalMoney))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("出账状态：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.newStatus))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("状态：")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.details.receiptAndPaymentStatus))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }, [
                    _c("span", [_vm._v("科目：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.details.subject))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flowing-item-diff" }, [
                    _c(
                      "table",
                      [
                        _c("tr", [
                          _c("td", [_vm._v("货物名")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("货物信息")])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.details.goods, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [_vm._v(_vm._s(item.goodsName))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.info))])
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-e442faca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e442faca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/cost/components/costTable/components/detailDialog/index.vue
// module id = null
// module chunks = 